module.exports = __webpack_public_path__ + "img/901583743.970a5d28.png";